
let state = {  image: 'toto' }


class LightboxStore {

  constructor () {
    this.state = {
      href: null,
      isVideo: false,
      visible: false
    }
  }

  close () {
    this.state.visible = false
  }

  getFileExtension3(filename) {
    return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
  }

}

//let lightboxStore = new LightboxStore()
export default new LightboxStore()


//let store = new LightboxStore()
//store.state.image = 'tata'
//store.name = 'Polygon';
//console.log("store.name " + store.name)
//store.state = {  image: 'tata' }
//console.log("store.state " + store.state.image)

//export default store
